import React from 'react'
import PropTypes from 'prop-types'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import classNames from 'classnames'

/**
 * Function to add classes to the ShiftCard component
 * to control the background and text color
 */

function ShiftListCard ({
  children,
  name,
  job,
  button,
  time,
  text,
  avatar,
  onClick,
  active = false,
  color = 'bg-white',
  shiftState = 'default'
}) {
  const cardColor = color => {
    if (color === 'green') {
      return !active ? 'bg-available border-available text-white' : 'bg-available text-white'
    }
    
    if (color === 'orange') {
      return !active ? 'bg-pending border-pending text-white' : 'bg-pending text-white'
    }
  
    return color
  }

  const textColor = color => (color === 'green' || color === 'orange') ? 'text-white' : 'text-gray-500'

  const _className = classNames(
    'overflow-hidden rounded-lg border-2',
    { 'border-gray-800': active },
    { 'border-white': !active && shiftState === 'default' },
    { 'border-dashed': shiftState === 'mine-pending' || shiftState === 'pending' },
    { 'border-pending': !active && shiftState === 'mine-pending' },
    { 'border-available': !active && shiftState === 'pending' },
    { 'border-pending': !active && shiftState === 'awaiting_approval' },
    cardColor(color),
    'cursor-pointer'
  )

  return (
    <div className={_className} onClick={onClick}>
      <div className='px-6 py-4 relative flex justify-between items-center'>
        <div className='flex items-center'>
          <AvatarWrapper>
            {avatar}
          </AvatarWrapper>
          <div className='mr-6 w-32 xl:w-40 whitespace-no-wrap'>
            <div className='font-medium text-base leading-tight truncate'>
              {name}
            </div>
            <div className={classNames('text-sm leading-tight', textColor(color))}>
              {job}
            </div>
          </div>
          <div>
            {children}
          </div>
        </div>
        <div className='flex items-center group space-x-4 ml-4 lg:space-x-8'>
          <div className={classNames('text-sm leading-tight', textColor(color))}>
            {text}
          </div>
          <div className='text-sm font-medium leading-tight whitespace-no-wrap'>
            {time}
          </div>
          <div>
            {button}
          </div>
        </div>
      </div>
    </div>
  )
}

ShiftListCard.defaultProps = {
  onClick: null
}

ShiftListCard.propTypes = {
  /**
     * Add employee name to card (below title)
     */
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  /**
     * Add (optional) note to card
     */
  note: PropTypes.string,
  /**
     * Add job name to card (below name)
     */
  job: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  /**
     * Add a button to the component (right side)
     */
  button: PropTypes.node,
  /**
     * Add a working time to the card (just left of the button)
     */
  time: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  /**
     * Add a short text the card (just left of the time)
     */
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  /**
     * Add an image of the person to the card
     */
  avatar: PropTypes.node,
  /**
     * Add badges component to shift
     */
  children: PropTypes.node,
  /**
     * OnClick event handler
     */
  onClick: PropTypes.func
}

export default ShiftListCard
